export type EventStatus = 'draft' | 'ready' | 'live' | 'closed' | 'archived'

export interface EventBranding {
  displayName?: string
  description?: string
  logoUrl?: string
  primaryColor?: string
  accentColor?: string
}

export type EventServiceMode = 'counter' | 'table' | 'takeaway'
export type EventDeliveryMode = 'together' | 'by_department'

export interface EventOperationsConfig {
  serviceModes: EventServiceMode[]
  defaultServiceMode: EventServiceMode
  tableCount: number
  requireCustomerName: boolean
  requireTableReference: boolean
  allowQuantityEdit: boolean
}

export interface EventDeliveryConfig {
  allowTogether: boolean
  allowByDepartment: boolean
  defaultMode: EventDeliveryMode
}

export interface EventRecord {
  id: string
  organizationId: string
  name: string
  startsAt: string | null
  endsAt: string | null
  status: EventStatus
  branding: EventBranding
  config: Record<string, unknown>
}

export interface EventDepartment {
  id: string
  eventId: string
  name: string
  code: string
  sortOrder: number
  enabled: boolean
}

export interface EventModuleConfig {
  moduleId: string
  enabled: boolean
  config: Record<string, unknown>
}

export interface EventDraftInput {
  name: string
  startsAt?: string | null
  endsAt?: string | null
  branding?: EventBranding
  config?: Record<string, unknown>
}

export const defaultOperationsConfig: EventOperationsConfig = {
  serviceModes: ['counter'],
  defaultServiceMode: 'counter',
  tableCount: 20,
  requireCustomerName: true,
  requireTableReference: false,
  allowQuantityEdit: true,
}

export function readOperationsConfig(config: Record<string, unknown>): EventOperationsConfig {
  const raw = (config.operations ?? {}) as Partial<EventOperationsConfig>
  const serviceModes = Array.isArray(raw.serviceModes) && raw.serviceModes.length ? raw.serviceModes : defaultOperationsConfig.serviceModes
  return {
    ...defaultOperationsConfig,
    ...raw,
    serviceModes,
    defaultServiceMode: serviceModes.includes(raw.defaultServiceMode as EventServiceMode) ? raw.defaultServiceMode as EventServiceMode : serviceModes[0],
    tableCount: Math.max(1, Math.min(300, Number(raw.tableCount) || defaultOperationsConfig.tableCount)),
  }
}
